class CreateInvestment {
    traderId;
    accountingEventId;
    cancelledAt;
    capitalGainPerBrick;
    couponDiscountPricePerBrick;
    couponDiscountTotalSavings;
    createdAt;
    folio;
    id;
    isAssigned;
    isCancelled;
    paymentPlanId;
    presaleDiscountAmountPerBrick;
    presaleDiscountPercentagePerBrick;
    presaleDiscountPricePerBrick;
    presaleDiscountTotalSavings;
    property;
    quantity;
    retailPricePerBrick;
    purchaseNumber;
    revolvingFundContributionPerBrick;
    totalPaid;
    totalPresalePrice;
    totalRetailPrice;
    totalRevolvingFundContribution;
    totalSavingsAmountPerBrick;
    totalWithVolumeDiscounts;
    updatedAt;
    volumeDiscountAmountPerBrick;
    volumeDiscountPercentagePerBrick;
    volumeDiscountPricePerBrick;
    volumeDiscountTotalSavings;
    constructor(data) {
        this.traderId = data.traderId;
        this.accountingEventId = data.accountingEventId;
        this.cancelledAt = data.cancelledAt ? new Date(data.cancelledAt) : undefined;
        this.capitalGainPerBrick = data.capitalGainPerBrick;
        this.couponDiscountPricePerBrick = data.couponDiscountPricePerBrick;
        this.couponDiscountTotalSavings = data.couponDiscountTotalSavings;
        this.createdAt = new Date(data.createdAt);
        this.folio = data.folio;
        this.id = data.id;
        this.isAssigned = data.isAssigned;
        this.isCancelled = data.isCancelled;
        this.paymentPlanId = data.paymentPlanId;
        this.presaleDiscountAmountPerBrick = data.presaleDiscountAmountPerBrick;
        this.presaleDiscountPercentagePerBrick = data.presaleDiscountPercentagePerBrick;
        this.presaleDiscountPricePerBrick = data.presaleDiscountPricePerBrick;
        this.presaleDiscountTotalSavings = data.presaleDiscountTotalSavings;
        this.property = data.property;
        this.quantity = data.quantity;
        this.retailPricePerBrick = data.retailPricePerBrick;
        this.purchaseNumber = data.purchaseNumber;
        this.revolvingFundContributionPerBrick = data.revolvingFundContributionPerBrick;
        this.totalPaid = data.totalPaid;
        this.totalPresalePrice = data.totalPresalePrice;
        this.totalRetailPrice = data.totalRetailPrice;
        this.totalRevolvingFundContribution = data.totalRevolvingFundContribution;
        this.totalSavingsAmountPerBrick = data.totalSavingsAmountPerBrick;
        this.totalWithVolumeDiscounts = data.totalWithVolumeDiscounts;
        this.updatedAt = new Date(data.updatedAt);
        this.volumeDiscountAmountPerBrick = data.volumeDiscountAmountPerBrick;
        this.volumeDiscountPercentagePerBrick = data.volumeDiscountPercentagePerBrick;
        this.volumeDiscountPricePerBrick = data.volumeDiscountPricePerBrick;
        this.volumeDiscountTotalSavings = data.volumeDiscountTotalSavings;
    }
}
export default CreateInvestment;
